import React, { useEffect, useState } from 'react';
import { getSucursales, crearSucursal, editarSucursal, eliminarSucursal } from '../services/api';
import { DEPARTAMENTOS, MUNICIPIOS } from '../data/dianUbicacion';

const EMPTY = { codigo: '', nombre: '', direccion: '', ciudad: '', departamento: '', codigo_departamento: '', codigo_municipio: '', codigo_postal: '', telefono: '', email: '', responsable: '', es_principal: false };

export default function Sucursales() {
  const [lista, setLista] = useState([]);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState('');

  const load = () => getSucursales().then(r => setLista(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const abrirNueva = () => { setForm(EMPTY); setErr(''); setModal(true); };
  const abrirEditar = (s) => { setForm({ ...EMPTY, ...s }); setErr(''); setModal(true); };

  const guardar = async () => {
    if (!form.nombre) return setErr('El nombre es requerido');
    setSaving(true); setErr('');
    try {
      if (form.id) await editarSucursal(form.id, form); else await crearSucursal(form);
      setModal(false); load();
    } catch (e) { setErr(e.response?.data?.error || 'Error al guardar'); }
    finally { setSaving(false); }
  };

  const borrar = async (s) => {
    if (!window.confirm(`¿Eliminar la sucursal "${s.nombre}"?`)) return;
    try { await eliminarSucursal(s.id); load(); } catch { alert('No se pudo eliminar'); }
  };

  return (
    <div>
      <div style={s.header}>
        <div><h1 style={s.h1}>Sucursales</h1><p style={s.sub}>Establecimientos / sedes de la empresa</p></div>
        <button style={s.btnPrimary} onClick={abrirNueva}>+ Nueva sucursal</button>
      </div>

      <div style={s.card}>
        <table style={s.table}>
          <thead><tr>{['Nombre', 'Código', 'Ciudad', 'Responsable', 'Teléfono', 'Acciones'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
          <tbody>
            {lista.length === 0 && <tr><td colSpan={6} style={s.empty}>Sin sucursales. Crea la primera con el botón de arriba.</td></tr>}
            {lista.map(x => (
              <tr key={x.id}>
                <td style={{ ...s.td, fontWeight: 600, color: '#e2e8f0' }}>{x.nombre}
                  {x.es_principal && <span style={s.badge}>Principal</span>}</td>
                <td style={s.td}>{x.codigo || '—'}</td>
                <td style={s.td}>{x.ciudad || '—'}{x.departamento ? `, ${x.departamento}` : ''}</td>
                <td style={s.td}>{x.responsable || '—'}</td>
                <td style={s.td}>{x.telefono || '—'}</td>
                <td style={s.td}>
                  <button style={s.link} onClick={() => abrirEditar(x)}>Editar</button>
                  <button style={{ ...s.link, color: '#fca5a5' }} onClick={() => borrar(x)}>Eliminar</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modal && (
        <div style={s.overlay}>
          <div style={s.modal}>
            <div style={s.modalHeader}><h2 style={s.modalTitle}>{form.id ? 'Editar sucursal' : 'Nueva sucursal'}</h2><button style={s.closeBtn} onClick={() => setModal(false)}>✕</button></div>
            <div style={s.modalBody}>
              <div style={s.row2}>
                <div style={s.field}><label style={s.label}>Nombre *</label>
                  <input style={s.input} value={form.nombre} onChange={e => setForm({ ...form, nombre: e.target.value })} /></div>
                <div style={s.field}><label style={s.label}>Código</label>
                  <input style={s.input} value={form.codigo} placeholder="Ej: SUC-01" onChange={e => setForm({ ...form, codigo: e.target.value })} /></div>
              </div>
              <div style={s.field}><label style={s.label}>Dirección</label>
                <input style={s.input} value={form.direccion} onChange={e => setForm({ ...form, direccion: e.target.value })} /></div>
              <div style={s.row2}>
                <div style={s.field}><label style={s.label}>Departamento</label>
                  <select style={s.input} value={form.codigo_departamento || ''}
                    onChange={e => { const d = DEPARTAMENTOS.find(x => x.code === e.target.value);
                      setForm({ ...form, codigo_departamento: e.target.value, departamento: d ? d.name : '', codigo_municipio: '', ciudad: '' }); }}>
                    <option value="">— Seleccionar —</option>
                    {DEPARTAMENTOS.map(d => <option key={d.code} value={d.code}>{d.name}</option>)}
                  </select></div>
                <div style={s.field}><label style={s.label}>Municipio / Ciudad</label>
                  <select style={s.input} value={form.codigo_municipio || ''} disabled={!form.codigo_departamento}
                    onChange={e => { const m = MUNICIPIOS.find(x => x.code === e.target.value);
                      setForm({ ...form, codigo_municipio: e.target.value, ciudad: m ? m.name : '' }); }}>
                    <option value="">{form.codigo_departamento ? '— Seleccionar —' : 'Elige departamento'}</option>
                    {MUNICIPIOS.filter(m => m.code.slice(0, 2) === form.codigo_departamento).map(m => <option key={m.code} value={m.code}>{m.name}</option>)}
                  </select></div>
              </div>
              <div style={s.row2}>
                <div style={s.field}><label style={s.label}>Código postal</label>
                  <input style={s.input} value={form.codigo_postal} onChange={e => setForm({ ...form, codigo_postal: e.target.value })} /></div>
                <div style={s.field}><label style={s.label}>Teléfono</label>
                  <input style={s.input} value={form.telefono} onChange={e => setForm({ ...form, telefono: e.target.value })} /></div>
              </div>
              <div style={s.row2}>
                <div style={s.field}><label style={s.label}>Email</label>
                  <input style={s.input} value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} /></div>
                <div style={s.field}><label style={s.label}>Responsable</label>
                  <input style={s.input} value={form.responsable} onChange={e => setForm({ ...form, responsable: e.target.value })} /></div>
              </div>
              <div style={{ marginTop: 10, padding: '10px 12px', background: '#0f172a', border: '1px solid #334155', borderRadius: 8 }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', color: '#cbd5e1', fontSize: 13 }}>
                  <input type="checkbox" checked={!!form.es_principal} onChange={e => setForm({ ...form, es_principal: e.target.checked })} />
                  Sucursal <b>principal</b> (sede matriz)
                </label>
              </div>
              {err && <div style={s.error}>{err}</div>}
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setModal(false)}>Cancelar</button>
              <button style={{ ...s.btnPrimary, opacity: saving ? 0.7 : 1 }} disabled={saving} onClick={guardar}>{saving ? 'Guardando…' : form.id ? 'Actualizar' : 'Crear sucursal'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 },
  h1: { fontSize: 24, fontWeight: 700, color: '#f1f5f9', margin: 0 },
  sub: { color: '#64748b', fontSize: 14, margin: '4px 0 0' },
  btnPrimary: { background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 20px', fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  btnSecondary: { background: '#334155', color: '#cbd5e1', border: 'none', borderRadius: 8, padding: '10px 20px', fontSize: 14, cursor: 'pointer' },
  card: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, overflow: 'hidden' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
  th: { background: '#0f172a', color: '#94a3b8', fontSize: 11, textTransform: 'uppercase', letterSpacing: '.5px', padding: '10px 14px', textAlign: 'left' },
  td: { padding: '10px 14px', color: '#cbd5e1', borderBottom: '1px solid #1a2332' },
  empty: { padding: 24, textAlign: 'center', color: '#64748b' },
  badge: { marginLeft: 8, fontSize: 10, color: '#34d399', border: '1px solid #34d39955', borderRadius: 4, padding: '1px 6px' },
  link: { background: 'none', border: 'none', color: '#60a5fa', cursor: 'pointer', fontSize: 13, padding: 0, marginRight: 12 },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, padding: 16 },
  modal: { background: '#1e293b', borderRadius: 16, width: '92%', maxWidth: 620, maxHeight: '92vh', display: 'flex', flexDirection: 'column', border: '1px solid #334155' },
  modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '18px 22px', borderBottom: '1px solid #334155' },
  modalTitle: { color: '#f1f5f9', fontSize: 18, fontWeight: 700, margin: 0 },
  closeBtn: { background: 'none', border: 'none', color: '#94a3b8', fontSize: 20, cursor: 'pointer' },
  modalBody: { padding: '18px 22px', overflowY: 'auto' },
  modalFooter: { display: 'flex', justifyContent: 'flex-end', gap: 10, padding: '14px 22px', borderTop: '1px solid #334155' },
  row2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 },
  field: { display: 'flex', flexDirection: 'column', gap: 4, marginBottom: 12 },
  label: { color: '#94a3b8', fontSize: 12 },
  input: { background: '#0f172a', border: '1px solid #334155', borderRadius: 8, height: 40, padding: '0 11px', color: '#f1f5f9', fontSize: 13, width: '100%', boxSizing: 'border-box' },
  error: { background: '#450a0a', border: '1px solid #b91c1c', color: '#fca5a5', padding: '8px 12px', borderRadius: 8, marginTop: 10, fontSize: 13 },
};
